import React from 'react';
import MaterialComponentParent from './MaterialComponentParent';
import GlbMaterialList from './GlbMaterialList';
import {
  findMaterialListAssetRoot,
  isGlbAssetSelection,
  isParentAssetSelection,
  shouldShowFullMaterialEditor,
  shouldShowMaterialComponent,
} from '../../utils/ThreeJsUtils/materialPropertyEditor';

const getSelectionId = (obj) =>
  obj ? (obj.uuid ?? obj._id ?? obj.id ?? obj.name ?? null) : null;

/**
 * GLB / shapes / images: material list + editor.
 * Other editable selections: full Material panel directly.
 */
const MaterialComponentNew = React.memo(({ objectt }) => {
  const { selectedObject } = objectt;

  if (!selectedObject) {
    return (
      <p className="text-xs text-gray-500 px-2 py-4">
        Select a mesh or model to edit materials.
      </p>
    );
  }

  if (!shouldShowMaterialComponent(selectedObject)) {
    return null;
  }

  // GLB / OBJ / FBX, shapes, and images: full material list.
  if (
    isGlbAssetSelection(selectedObject) ||
    isParentAssetSelection(selectedObject) ||
    findMaterialListAssetRoot(selectedObject)
  ) {
    return <GlbMaterialList objectt={objectt} />;
  }

  if (!shouldShowFullMaterialEditor(selectedObject)) {
    return (
      <p className="text-xs text-gray-500 px-2 py-4">
        Select a mesh to edit materials.
      </p>
    );
  }

  return <MaterialComponentParent objectt={objectt} />;
}, (prevProps, nextProps) => {
  const prev = prevProps.objectt?.selectedObject;
  const next = nextProps.objectt?.selectedObject;
  if (
    shouldShowMaterialComponent(prev) !== shouldShowMaterialComponent(next)
  ) {
    return false;
  }
  if (isParentAssetSelection(prev) !== isParentAssetSelection(next)) return false;
  if (isGlbAssetSelection(prev) !== isGlbAssetSelection(next)) return false;
  if (
    !!findMaterialListAssetRoot(prev) !== !!findMaterialListAssetRoot(next)
  ) {
    return false;
  }
  if (shouldShowFullMaterialEditor(prev) !== shouldShowFullMaterialEditor(next)) {
    return false;
  }
  return getSelectionId(prev) === getSelectionId(next);
});

export default MaterialComponentNew;
